import { Link } from "react-router-dom";
import { Sparkles, Target, Users, Award } from "lucide-react";
import SEO from "@/components/SEO";

export default function AboutPage() {
  return (
    <div className="max-w-[1000px] mx-auto px-6 lg:px-10 py-16">
      <SEO title="About us" description="Noxi is a brutalist-first freelance marketplace built by senior engineers and operators. Fair fees, verified sellers, fast payouts."/>
      <div className="overline text-primary mb-2">◆ ABOUT US</div>
      <h1 className="text-4xl lg:text-5xl font-bold tracking-tight mb-6">Craft meets contract.</h1>
      <p className="text-lg text-muted-foreground mb-10 max-w-2xl">
        Noxi is a brutalist-first marketplace where buyers get sharp work and sellers get paid — fast.
        We're the anti-marketplace: no fluff, no gimmicks, just clean pipes between makers and the people who need them.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mb-14">
        <Card icon={<Target className="w-5 h-5"/>} title="Our mission">
          Give independent professionals a place that respects their time and their craft.
          No paywalls, no games — just fair fees and fast payouts.
        </Card>
        <Card icon={<Users className="w-5 h-5"/>} title="Who we serve">
          Buyers from startups to studios, sellers from freelancers to specialised studios.
          If you can ship it, someone here needs it.
        </Card>
        <Card icon={<Sparkles className="w-5 h-5"/>} title="What makes Noxi different">
          Fixed 20% platform fee. Live dispute chat with an admin in the room.
          Real-time messaging. Bank-grade payouts. No hidden bidding wars.
        </Card>
        <Card icon={<Award className="w-5 h-5"/>} title="Our promise">
          Verified sellers. Escrow-style order flow. Refund if it isn't right.
          The work speaks — we just make sure it lands.
        </Card>
      </div>

      <div className="border border-foreground/15 p-8 bg-card">
        <div className="overline mb-2">◆ THE TEAM</div>
        <h2 className="text-2xl font-bold mb-2">Small, senior, obsessed with craft.</h2>
        <p className="text-muted-foreground">Noxi is built by a tight team of engineers, designers and operators who've all shipped from both sides — as freelancers and as buyers. We built the platform we wished existed.</p>
        <div className="mt-6 flex gap-3">
          <Link to="/browse" data-testid="about-browse-cta" className="bg-primary text-primary-foreground px-5 py-2.5 mono text-xs hover:bg-primary/90">EXPLORE GIGS</Link>
          <Link to="/contact" data-testid="about-contact-cta" className="border border-foreground/30 px-5 py-2.5 mono text-xs hover:bg-foreground hover:text-background">TALK TO US</Link>
        </div>
      </div>
    </div>
  );
}

function Card({ icon, title, children }) {
  return (
    <div className="border border-foreground/15 bg-card p-6">
      <div className="flex items-center gap-2 overline mb-3">{icon} ◆ {title}</div>
      <p className="text-sm text-foreground/80 leading-relaxed">{children}</p>
    </div>
  );
}
